export default __webpack_public_path__ + "static/media/aqua1.785a9db9.png";